<template>
  <aside class="admin-sidebar">
    <div class="sidebar-header">
      <img src="../assets/logo-white.png" style="cursor:pointer" alt="Archvarsity" height="60" @click="redirectHome"/>
    </div>

    <nav v-for="section in filteredSections" :key="section.label">
      <ul>
        <li v-for="item in section.items" :key="item.label">
          <div v-if="item.children" class="nav-item-with-submenu">
            <div
              class="d-flex justify-content-between align-items-center nav-item"
              @click="toggleSubmenu(item.label)"
            >
              <router-link :to="item.path" class="nav-link" @click.stop>
                <i :class="item.icon"></i>
                <span class="text-left">{{ item.label }}</span>
              </router-link>
              <i
                class="fa toggle-icon"
                :class="
                  isSubmenuOpen(item.label)
                    ? 'fa-chevron-down'
                    : 'fa-chevron-right'
                "
              ></i>
            </div>

            <ul v-show="isSubmenuOpen(item.label)" class="submenu">
              <li v-for="sub in item.children" :key="sub.label">
                <router-link :to="sub.path" class="nav-link">
                  <i :class="sub.icon"></i>
                  <span>{{ sub.label }}</span>
                </router-link>
              </li>
            </ul>
          </div>

          <div v-else>
            <router-link
              :to="item.path"
              class="nav-link"
              @click="handleSpecial(e, item)"
            >
              <i :class="item.icon"></i>
              <span>{{ item.label }}</span>
            </router-link>
          </div>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
import { useAuth } from "@/composables/useAuth";

export default {
  name: "AdminSidebar",
  data() {
    return {
      openSubmenus: [],
      sections: [
        {
          label: "Member",
          roles: ["student"],
          items: [
            // { label: 'Dashboard', path: '/dashboard', icon: 'fas fa-tachometer-alt' },
            {
              label: "Mentors",
              path: "/dashboard/mentors",
              icon: "fas fa-users",
            },
            {
              label: "My Mentors",
              path: "/dashboard/my-mentors",
              icon: "fas fa-user-friends",
            },
            {
              label: "My Notes",
              path: "/dashboard/my-notes",
              icon: "fas fa-sticky-note",
            },
            {
              label: "Profile",
              path: "/dashboard/profile",
              icon: "fas fa-user-circle",
            },
            {
              label: "My Courses",
              path: "/dashboard/mycourses",
              icon: "fas fa-graduation-cap",
            },
            {
              label: "Find Courses",
              path: "/courses",
              icon: "fas fa-search",
              isSpecial: true,
              // scrollTo: "courses",
            },
          ],
        },
        {
          label: "Mentor",
          roles: ["mentor"],
          items: [
            {
              label: "Dashboard",
              path: "/dashboard/mentor-dashboard",
              icon: "fas fa-tachometer-alt",
            },
            {
              label: "My Notes",
              path: "/dashboard/mentor-notes",
              icon: "fas fa-sticky-note",
            },
            {
              label: "Mentor Overview",
              path: "/dashboard/mentor-profile",
              icon: "fas fa-user-circle",
            },
            {
              label: "Profile",
              path: "/dashboard/profile",
              icon: "fas fa-user-circle",
            },
          ],
        },
        {
          label: "Teacher",
          roles: ["teacher"],
          items: [
            {
              label: "Course Management",
              path: "/dashboard/allcourses",
              icon: "fas fa-book-open",
            },
            {
              label: "Teacher Profile",
              path: "/dashboard/teacher-profile",
              icon: "fas fa-user-circle",
            },
            {
              label: "Profile",
              path: "/dashboard/profile",
              icon: "fas fa-user-circle",
            },
          ],
        },
        {
          label: "Admin",
          roles: ["admin"],
          items: [
            // { label: 'Dashboard', path: '/dashboard', icon: 'fas fa-tachometer-alt' },
            {
              label: "Course Management",
              path: "/dashboard/allcourses",
              icon: "fas fa-book-open",
               children: [
                {
                  label: "Courses",
                  path: "/dashboard/courses",
                  icon: "fas fa-file-signature",
                },
                {
                  label: "Programs",
                  path: "/dashboard/programs",
                  icon: "fas fa-file-signature",
                },
                {
                  label: "Trainings",
                  path: "/dashboard/trainings",
                  icon: "fas fa-file-signature",
                },
              ],
            },
            {
              label: "User Management",
              path: "/dashboard/allusers",
              icon: "fas fa-users-cog",
              children: [
                {
                  label: "Students",
                  path: "/dashboard/students",
                  icon: "fas fa-file-signature",
                },
                {
                  label: "Teachers",
                  path: "/dashboard/teachers",
                  icon: "fas fa-file-signature",
                },
                {
                  label: "Mentors",
                  path: "/dashboard/all-mentors",
                  icon: "fas fa-file-signature",
                },
              ] 
            },
            {
              label: "Profile",
              path: "/dashboard/profile",
              icon: "fas fa-user-circle",
            },
            {
              label: "Feedbacks",
              path: "/dashboard/user-feedback",
              icon: "bi bi-inbox",
            },
            {
              label: "Mentor Management",
              path: "/dashboard/mentorship/mentors",
              icon: "fas fa-user-tie",
              children: [
                {
                  label: "Applications",
                  path: "/dashboard/mentorship/applications",
                  icon: "fas fa-file-signature",
                },
              ],
            },
            {
              label: "CMS",
              path: "/dashboard/cms",
              icon: "fas fa-user-circle",
              children: [
                {
                  label: "Privacy Section",
                  path: "/dashboard/cms/privacy",
                  icon: "fas fa-file-signature",
                },
                {
                  label: "Terms And Service",
                  path: "/dashboard/cms/terms-service",
                  icon: "fas fa-file-signature",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  computed: {
    accountType() {
      const { role } = useAuth();
      return role;
    },
    filteredSections() {
      return this.sections.filter((section) =>
        section.roles.includes(this.accountType)
      );
    },
  },
  methods: {
    redirectHome() {
      this.$router.push("/");
    },
    toggleSubmenu(label) {
      const index = this.openSubmenus.indexOf(label);
      if (index > -1) {
        this.openSubmenus.splice(index, 1);
      } else {
        this.openSubmenus.push(label);
      }
    },
    isSubmenuOpen(label) {
      return this.openSubmenus.includes(label);
    },
    handleSpecial(event, item) {
      if (item.isSpecial && item.scrollTo) {
        // event.preventDefault();
        this.$router.push("/").then(() => {
          const el = document.getElementById(item.scrollTo);
          if (el) el.scrollIntoView({ behavior: "smooth" });
        });
      }
    },
  },
};
</script>

<style scoped>
.admin-sidebar {
  width: 275px;
  background-color: #2C5C9E;  
  color: white;
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
}

.sidebar-header {
  padding: 20px;
  background-color: #2C5C9E;
  text-align: center;
  margin-bottom: 15px;
}

.admin-sidebar ul {
  list-style: none;
  padding: 0 15px;
  margin: 0;
}

.admin-sidebar li {
  margin: 5px 0;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 14px;
  border-radius: 5px;
  transition: all 0.3s ease;
  width: 100%;
}

.nav-link:hover,
.nav-link.router-link-exact-active {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.nav-link i {
  margin-right: 12px;
  font-size: 16px;
  width: 20px;
  text-align: center;
}

.nav-item-with-submenu {
  display: flex;
  flex-direction: column;
}

.nav-item {
  padding: 0;
  cursor: pointer;
}

.toggle-icon {
  margin-left: auto;
  padding: 0 7px;
  font-size: 10px;
  transition: transform 0.3s ease;
}

.submenu {
  list-style: none;
  padding-left: 20px;
  margin-top: 5px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.submenu .nav-link {
  padding: 10px 15px;
  font-size: 13px;
}

.submenu .nav-link i {
  font-size: 14px;
}

/* Active state for parent items with active children */
.nav-item-with-submenu .router-link-exact-active {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}
</style>
